(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["unika-bundle-selector"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-unika-bundle]').forEach((bundle)=>{
    if(bundle.dataset.ready)return;bundle.dataset.ready='1';
    const products=JSON.parse(bundle.querySelector('[data-bundle-products]').textContent);
    const choices=bundle.querySelector('[data-bundle-choices]');
    const addButton=bundle.querySelector('[data-bundle-add]');
    const message=bundle.querySelector('[data-bundle-message]');
    const dialog=bundle.querySelector('[data-bundle-dialog]');
    const standardForm=bundle.closest('product-info')?.querySelector('product-form');
    let activeChoice;
    const fillChoice=(choice,index)=>{
      const item=products[index];choice.dataset.productIndex=index;
      choice.querySelector('img').src=item.image;choice.querySelector('strong').textContent=item.title;
      const select=choice.querySelector('select');select.innerHTML='';
      item.variants.forEach((variant)=>{const option=document.createElement('option');option.value=variant.id;option.textContent=variant.title;option.disabled=!variant.available;select.append(option)});
    };
    const render=(count)=>{
      choices.innerHTML='';choices.hidden=count===1;addButton.hidden=count===1;if(standardForm)standardForm.hidden=count!==1;
      for(let n=0;n<count&&count>1;n+=1){
        const choice=document.createElement('div');choice.className='unika-bundle__choice';
        choice.innerHTML='<img alt=""><div class="unika-bundle__choice-body"><strong></strong><select data-bundle-variant aria-label="Choose color and size"></select><button type="button" class="unika-bundle__choose">Choose another product</button></div>';
        fillChoice(choice,n%products.length);
        choice.querySelector('.unika-bundle__choose').addEventListener('click',()=>{activeChoice=choice;dialog.showModal()});
        choices.append(choice);
      }
    };
    bundle.querySelectorAll('input[type=radio]').forEach((radio)=>radio.addEventListener('change',()=>{message.textContent='';render(Number(radio.value))}));
    bundle.querySelector('[data-dialog-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',(event)=>{if(event.target===dialog)dialog.close()});
    bundle.querySelectorAll('[data-product-index]').forEach((card)=>card.addEventListener('click',()=>{if(activeChoice)fillChoice(activeChoice,Number(card.dataset.productIndex));dialog.close()}));
    addButton.addEventListener('click',async()=>{
      addButton.disabled=true;message.textContent='';
      const items=[...choices.querySelectorAll('[data-bundle-variant]')].map((select)=>({id:Number(select.value),quantity:1}));
      try{const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});if(!response.ok)throw new Error();message.textContent='Bundle added to your cart.';document.dispatchEvent(new CustomEvent('cart:refresh'))}catch(error){message.textContent='Please check your selections and try again.'}
      addButton.disabled=false;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["unika-size-guide-drawer"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.unika-size-guide').forEach((guide)=>{
    const drawer=guide.querySelector('[data-size-guide-drawer]');
    guide.querySelector('[data-size-guide-open]').addEventListener('click',()=>drawer.showModal());
    guide.querySelector('[data-size-guide-close]').addEventListener('click',()=>drawer.close());
    drawer.addEventListener('click',(event)=>{if(event.target===drawer)drawer.close()});
  });
  } catch(e) { console.error(e); }
})();

})();
